<div class="fiscal-year-met" *ngIf="selectedTab.id=='FiscalYearTestMet' && isInitialized">
  <form [formGroup]="fiscalYearMet">
    <div class="input-field">
      <span> Jurisdiction</span>
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <input formControlName="jurisdiction" matInput readonly>
      </mat-form-field>
    </div>
    <div class="input-field">
      <span>Ultimate Parent's Fiscal Year Start Date</span>
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <input [value]="fiscalYearMet.get('ultimateParentFiscalYearStartDate').value | date:'shortTime'"
               formControlName="ultimateParentFiscalYearStartDate" matInput readonly>
      </mat-form-field>
    </div>

    <div>
      <div>
        <mat-checkbox formControlName="cbcRequiredResidentCheckBox" (change)="updateCbcRequiredEffectiveForResident()">
          CbC Rules effective for resident parents from
        </mat-checkbox>
      </div>
      <div>
        <mat-form-field appearance="outline" class="orbitax-date-picker flex-1-1-50">
          <input matInput [disabled]='!iscbCRulesEffectiveResidentEnabled'
                 formControlName="cbcRequiredEffectiveForResident" [matDatepicker]="picker1" (dateInput)="dateInput()">
          <mat-error *ngIf="fiscalYearMet.get('cbcRequiredEffectiveForResident').hasError('lessThenEqualDefaultDate')">
            Input a valid date.
          </mat-error>
        </mat-form-field>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker [disabled]='!iscbCRulesEffectiveResidentEnabled' #picker1></mat-datepicker>
        <!-- <mat-error *ngIf="cbcRequiredEffectiveForResident.invalid">Input a valid Date.</mat-error> -->
      </div>
    </div>


    <div>
      <div>
        <mat-checkbox formControlName="cbcRequiredNonResidentCheckBox"
                      (change)="updateCbcRequiredEffectiveForNonResident()">CbC Rules effective for non-resident parents
          from
        </mat-checkbox>
      </div>
      <div>
        <mat-form-field appearance="outline" class="orbitax-date-picker flex-1-1-50">
          <input matInput [disabled]='!iscbCRulesEffectiveNonResidentEnabled'
                 formControlName="cbcRequiredEffectiveForNonResident" [matDatepicker]="picker2"
                 (dateInput)="dateInput()">
          <mat-error
            *ngIf="fiscalYearMet.get('cbcRequiredEffectiveForNonResident').hasError('lessThenEqualDefaultDate')">
            Input a valid date.
          </mat-error>
        </mat-form-field>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker [disabled]='!iscbCRulesEffectiveNonResidentEnabled' #picker2></mat-datepicker>
        <!-- <mat-error *ngIf="cbcRequiredEffectiveForResident.invalid">Input a valid Date.</mat-error> -->
      </div>
    </div>
  </form>


</div>


<div class="annual-revenue-threshold-met" *ngIf="selectedTab.id=='AnnualRevenueThresholdMet' && isInitialized">
  <form [formGroup]="annualRevenueThresholdMetForm">
    <div>
      <mat-checkbox formControlName="annualRevenueThresholdApplicable"
                    (change)="updateAnnualRevenueThresholdApplicable()">Annual revenue threshold logic applicable
      </mat-checkbox>
    </div>


    <div class="multiple-input-field">
      <div>Consolidated Group Revenue in Previous Year*</div>
      <div>
        <mat-form-field appearance="outline" style="padding-right: 20px;" class="full-grow-no-shrink-no-basis">
          <input formControlName="consolidatedRevenuePreviousYearAmount" matInput readonly>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
          <input formControlName="consolidatedRevenuePreviousYearCurrency" matInput readonly>
        </mat-form-field>
      </div>
    </div>


    <div class="multiple-input-field">
      <div>Consolidated Group Revenue converted to local currency using average exchange rate</div>
      <div>
        <mat-form-field appearance="outline" style="padding-right: 20px;" class="full-grow-no-shrink-no-basis">
          <input formControlName="consolidatedRevenueLocalAmount" matInput readonly>
        </mat-form-field>
        <mat-form-field appearance="outline" style="padding-right: 20px;" class="full-grow-no-shrink-no-basis">
          <mat-select [disabled]='!annualThresholdApplicable' formControlName="consolidatedRevenueLocalCurrency">
            <mat-option *ngFor="let data of currencies" [value]="data.value">
              {{data.text}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
          <input [readonly]='!annualThresholdApplicable' formControlName="consolidatedRevenueLocalExchangeRate"
                 matInput>
          <mat-error
            *ngIf="annualRevenueThresholdMetForm.get('consolidatedRevenueLocalExchangeRate').hasError('lessThenZero')">
            Input a valid Exchange rate.
          </mat-error>
          <mat-error
            *ngIf="annualRevenueThresholdMetForm.get('consolidatedRevenueLocalExchangeRate').hasError('notNumber')">
            Input a Number.
          </mat-error>
          <mat-error
            *ngIf="annualRevenueThresholdMetForm.get('consolidatedRevenueLocalExchangeRate').hasError('required')">
            Exchange rate is required.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="multiple-input-field">
      <div>{{jurisdictionCountry.name}}'s CbC reporting threshold</div>
      <div>
        <mat-form-field appearance="outline" style="padding-right: 20px;" class="full-grow-no-shrink-no-basis">
          <input [readonly]='!annualThresholdApplicable' formControlName="cbcRportingThresholdAmount" matInput>
          <mat-error *ngIf="annualRevenueThresholdMetForm.get('cbcRportingThresholdAmount').hasError('lessThenZero')">
            Input valid Threshold amount.
          </mat-error>
          <mat-error *ngIf="annualRevenueThresholdMetForm.get('cbcRportingThresholdAmount').hasError('notNumber')">
            Input a number.
          </mat-error>
          <mat-error *ngIf="annualRevenueThresholdMetForm.get('cbcRportingThresholdAmount').hasError('required')">
            Threshold amount is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="padding-right: 20px;" class="full-grow-no-shrink-no-basis">
          <mat-select [disabled]='!annualThresholdApplicable' formControlName="cbcRportingThresholdCurrency">
            <mat-option *ngFor="let data of currencies" [value]="data.value">
              {{data.text}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>


  <div>
    <h5>CbC Report Required in {{jurisdictionCountry.name}} - {{cbcReportRequired}}</h5>
    <div class="cbc-required-overwrite">
      <mat-checkbox style="width: 100%;padding-top: 3px;" class="example-margin"
                    [(ngModel)]="cbcReportRequiredOverwrite"><span>Overwrite</span></mat-checkbox>
      <mat-radio-group class="overwrite-options" [(ngModel)]="cbcReportRequired">
        <mat-radio-button class="overwrite-option-value" [disabled]="!cbcReportRequiredOverwrite" value="Yes">Yes
        </mat-radio-button>
        <mat-radio-button class="overwrite-option-value" [disabled]="!cbcReportRequiredOverwrite" value="No">No
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>
